module.exports = __webpack_public_path__ + "img/regalo2.6e4d99c6.webp";